import React from 'react'
import styles from './Loader.module.css'
export default function Loader() {
  return (
    <div className={styles.loaderHolder}>
<div className={styles.customLoader}></div> 
</div>
 )
}
